import { useEffect } from '../../InBuildImports';
import Offcanvas from 'react-bootstrap/Offcanvas';
import { Properties, systemConfiguration, includeScripts, includeBootstrapCss, includeBundleBootstrapCss } from '../../CommonImports';
import './../css/GSideBar.css';
import './../css/Gtop.css';
import './../css/GFooter.css';
import './../css/GAnimetion.css';
import './../css/GServices.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import GHeader from "./GHeader";
import GFooter from "./GFooter";
import GSignImg from './GSignImg';
import GJobsHubMenu from './GJobsHubMenu';



function GServices() {
    const sasToken = systemConfiguration.AZURE_FTP_GRASTECH3JOBS_SAAS_TOKEN;
    const mediaUrl = 'https://grastechftp.blob.core.windows.net/grastech3jobs/media/icons/';

    useEffect(() => {
        includeBootstrapCss();
        includeBundleBootstrapCss();
        includeScripts();
        document.addEventListener("DOMContentLoaded", function () {
            if (window.innerWidth >= 992) {
                const sidebar = Offcanvas(document.getElementById(Properties.SIDEBAR_MENU_PROP));
                sidebar.show();
            }
        });
    }, []);


    return (
        <div>
            <GHeader />
            <GJobsHubMenu />


            <section className="py-5">
                <div className="container">


                    <div className="row justify-content-center text-center mb-4">
                        <div className="col-lg-8 col-md-10 col-12">

                            <h1 className="fw-bold wow animate__animated animate__fadeInUp">
                                Our Services
                            </h1>

                            <p className="text-muted wow animate__animated animate__fadeInUp">
                                We provide mobile app development, custom software solutions, and modern web development with secure, scalable, and high-performance technology.
                            </p>

                        </div>
                    </div>


                    <div className="row justify-content-center">
                        <div className="col-lg-10 col-12">

                            <div className="gbox-banner-services--inner position-relative overflow-hidden rounded-4 wow animate__animated animate__fadeInUp">

                                <img
                                    src={mediaUrl + "Gbanner-our-services.png?" + sasToken}
                                    // alt="GJobhub Services"
                                    className="img-fluid"
                                />


                                <a
                                    href="https://www.youtube.com/watch?v=ea-I4sqgVGY"
                                    className="position-absolute top-50 start-50 translate-middle btn btn-light rounded-circle d-flex align-items-center justify-content-center shadow"
                                    style={{ width: "70px", height: "70px" }}
                                >
                                    ▶
                                </a>

                            </div>

                        </div>
                    </div>

                </div>
            </section>

            <section className="py-5">
                <div className="container">

                    <div className="row justify-content-center">
                        <div className="col-lg-8 col-md-10 col-12 text-center">
                            <div className="mw-650 mx-auto">
                                <h4 className="fw-semibold wow animate__animated animate__fadeInUp">
                                    Rapidly provision one to thousands of Droplets in seconds
                                </h4>
                            </div>
                        </div>
                    </div>

                    <div className="row mt-5 g-4">

                        <div className="col-lg-3 col-md-6 col-sm-6 col-12">
                            <div className="text-center wow animate__animated animate__fadeInUp">
                                <div className="mb-3">
                                    <img
                                        src={mediaUrl + "Gready-project.svg?" + sasToken}
                                        className="img-fluid"
                                        alt="Ready Jobs"
                                    />
                                </div>
                                <h3><span className="count">0</span>00+</h3>
                                <strong>Ready perfect jobs</strong>
                                <p className="text-muted mb-0">A place to think and track ideas</p>
                            </div>
                        </div>

                        <div className="col-lg-3 col-md-6 col-sm-6 col-12">
                            <div className="text-center wow animate__animated animate__fadeInUp" data-wow-delay=".1s">
                                <div className="mb-3">
                                    <img
                                        src={mediaUrl + "Gcandidate-call.svg?" + sasToken}
                                        className="img-fluid"
                                        alt="Candidate Calls"
                                    />
                                </div>
                                <h3><span className="count">0</span>00K</h3>
                                <strong>Candidate calls</strong>
                                <p className="text-muted mb-0">A place to think and track ideas</p>
                            </div>
                        </div>

                        <div className="col-lg-3 col-md-6 col-sm-6 col-12">
                            <div className="text-center wow animate__animated animate__fadeInUp" data-wow-delay=".2s">
                                <div className="mb-3">
                                    <img
                                        src={mediaUrl + "Gjob-posted.svg?" + sasToken}
                                        className="img-fluid"
                                        alt="Jobs Posted"
                                    />
                                </div>
                                <h3><span className="count">0</span>00</h3>
                                <strong>Jobs posted</strong>
                                <p className="text-muted mb-0">A place to think and track ideas</p>
                            </div>
                        </div>

                        <div className="col-lg-3 col-md-6 col-sm-6 col-12">
                            <div className="text-center wow animate__animated animate__fadeInUp" data-wow-delay=".3s">
                                <div className="mb-3">
                                    <img
                                        src={mediaUrl + "Gcomplete-jobs.svg?" + sasToken}
                                        className="img-fluid"
                                        alt="Complete Jobs"
                                    />
                                </div>
                                <h3><span className="count">0</span>00K</h3>
                                <strong>Complete Jobs</strong>
                                <p className="text-muted mb-0">A place to think and track ideas</p>
                            </div>
                        </div>

                    </div>
                </div>
            </section>

            <section className="section-box my-5">
                <GSignImg />
            </section>
            <GFooter />
        </div>
    );
}
export default GServices;